import { sameValueForEveryLocale } from "../../utils/sameValueForEveryLocale.js";
import type { LocalizedString } from "../Locale.js";
import { SubscriptionSelection } from "../SubscriptionSelection.js";

export const subscriptionSelectionNameMap: Record<SubscriptionSelection, LocalizedString> = {
	[SubscriptionSelection.MothersBlend]: sameValueForEveryLocale("Mother’s Blend"),
	[SubscriptionSelection.Cafeina]: sameValueForEveryLocale("Cafeina"),
	[SubscriptionSelection.FathersChoice]: sameValueForEveryLocale("Father’s Choice"),
};
